export default {
      id: "Icon--trackEnd-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--trackEnd",
      toString: function () {
        return this.url;
      }
    }